import { program } from "../transferWrapper";

program.parse(process.argv);
